import { render } from "./errorPage.vue?vue&type=template&id=77530de6"
const script = {}

import "./errorPage.vue?vue&type=style&index=0&id=77530de6&lang=less&scope=true"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__